module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-bank-04b3a1aa831e09e64bb70d4917112f87.svg";